const feedbacks = {
  toasts: {
    create: {
      success: 'Feedback erfolgreich erstellt',
      error: 'Beim Erstellen des Feedbacks ist ein Fehler aufgetreten',
    },
    fetch: {
      error: 'Beim Abrufen der Feedbacks ist ein Fehler aufgetreten',
    },
    delete: {
      error: 'Beim Löschen des Feedbacks ist ein Fehler aufgetreten',
    },
  },
  deleteModal: {
    header: 'Feedback löschen',
    body: 'Sie sind dabei, ein Feedback zu löschen',
    bulkBody: 'Sie sind dabei, {{num}} Feedbacks zu löschen',
    success: 'Feedback wurde erfolgreich gelöscht',
  },
  table: {
    headers: {
      date: 'Datum',
      source: 'Quelle',
      id: 'ID',
      externalId: 'Externe ID',
      flight: 'Flug',
      airline: 'Fluggesellschaft',
      account: 'Konto',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      feedback: 'Feedback',
      rating: 'Bewertung',
      by: 'Von',
      phone: 'Telefon',
      contact: 'Kontakt',
    },
    filters: {
      flight: 'Flug',
      airline: 'Fluggesellschaft',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
    },
    source: {
      crewLink: 'CrewLink',
      qr: 'QR',
      tripCard: 'Fahrtkarte',
    },
    actions: {
      delete: 'Löschen',
    },
    toolTip: {
      noPermission: 'Aktion nicht erlaubt: Berechtigung erforderlich',
    },
  },
};

export default feedbacks;
